import React, { Component } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { Billboard, LargeWrapper } from '@raysync/common/components'
import intl from 'react-intl-universal'
import { BannerContainer, BannerTitle } from './banner.atom'

class Banner extends Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            banner: file(relativePath: { regex: "/banner.png/" }) {
              ...fluidImage
            }
          }
        `}
        render={({ banner }) => (
          <BannerContainer>
            <LargeWrapper>
              <BannerTitle>
                {intl.get('news.title')}
                <span>{intl.get('news.sub-title')}</span>
              </BannerTitle>
            </LargeWrapper>
            <Billboard fluid={banner.childImageSharp.fluid} />
          </BannerContainer>
        )}
      />
    )
  }
}
export default Banner
